import BananaLanguage from './language.js'
import HebrewLanguage from './he.js'
import BosnianLanguage from './bs.js'
import DolnoserbskiLanguage from './dsb.js'
import HornjoserbsceLanguage from './hsb.js'
import FinnishLanguage from './fi.js'
import RussianLanguage from './ru.js'
import SlovenianLanguage from './sl.js'
import LatinLanguage from './la.js'
import ArmenianLanguage from './hy.js'
import IrishLanguage from './ga.js'
import HungarianLanguage from './hu.js'
import OssetianLanguage from './os.js'
import UkrainianLanguage from './uk.js'

export default {
  bs: BosnianLanguage,
  default: BananaLanguage,
  dsb: DolnoserbskiLanguage,
  fi: FinnishLanguage,
  ga: IrishLanguage,
  he: HebrewLanguage,
  hsb: HornjoserbsceLanguage,
  hu: HungarianLanguage,
  hy: ArmenianLanguage,
  la: LatinLanguage,
  os: OssetianLanguage,
  ru: RussianLanguage,
  sl: SlovenianLanguage,
  uk: UkrainianLanguage
}
